// extracted by mini-css-extract-plugin
module.exports = {"container":"e_nw","pending":"e_ow","slider":"e_pw","imageContainer":"e_qw","image":"e_rw","button":"e_sw","prevButton":"e_tw","nextButton":"e_uw","disabled":"e_vw"};